export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
